"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var KsysRequest_1 = require("../KsysRequest");

var SavedSearchEntity =
/** @class */
function (_super) {
  __extends(SavedSearchEntity, _super);

  function SavedSearchEntity() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getExplicitEndpoint = function () {
      return '/fund/savedSearchEntity';
    };

    return _this;
  }

  Object.defineProperty(SavedSearchEntity.prototype, "endpointConfiguration", {
    get: function get() {
      return this.getEndpointConfiguration("fund", "SavedSearchEntity");
    },
    enumerable: true,
    configurable: true
  });
  return SavedSearchEntity;
}(KsysRequest_1.KsysRequest);

exports.SavedSearchEntity = SavedSearchEntity;